<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="components/airline-form"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/as-form-skeleton"></require>

  <div class="admin-airline-detail-screen">
    <form class="container-fluid">
      <as-page-header heading.bind="title">
        <div class="sc-buttons-container text-nowrap" slot="aside" if.bind="loaded">
          <button type="button" class="btn btn-danger" af-mutex-click.call="archive()" if.bind="archiveButtonVisible" title="Click to archive this airline" bs-tooltip>
            <i class="fas fa-trash"></i>
          </button>
          <button type="button" class="btn btn-success" af-mutex-click.call="restore()" if.bind="restoreButtonVisible" title="Click to restore this airline" bs-tooltip>
            <i class="fas fa-trash-restore"></i>
          </button>
          <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
            <i class="fas fa-paper-plane"></i> ${id ? 'Save Changes' : 'Submit Form'}
          </button>
          <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
            ${id ? 'Cancel' : 'Reset'}
          </button>
        </div>
      </as-page-header>
      <airline-form class="sc-content-appear" model.bind="model" autofocus.bind="!id" disabled.bind="!editing" changed.bind="changed" debug="true" if.bind="loaded"></airline-form>
      <as-form-skeleton else></as-form-skeleton>
    </form>
  </div>
</template>
